module.exports = __webpack_public_path__ + "img/stanford.0bfa932b.jpg";